import { z } from 'zod';

export const teacherOverviewSchema = z.object({
  type: z.literal('teacherOverview'),
  data: z.array(
    z.object({
      classInfo: z.object({
        id: z.string(),
        name: z.string(),
      }),
      studentCount: z.number(),
      totalTimeEngaged: z.number().nullable(),
      articlesViewed: z.number(),
      annotationsPerArticle: z.number().nullable(),
      videosWatched: z.number(),
      activitiesCompleted: z.number(),
      avgQuizScore: z.number().nullable(),
    })
  ),
});

export type TeacherOverviewResponse = z.infer<typeof teacherOverviewSchema>;
